import { Observable } from 'rxjs';
import _ from 'lodash';
import { Store } from 'redux';
import { ActionsObservable } from 'redux-observable';

import DeedsApi from 'entities/deed/api';
import { selectUpcomingDeedsLoaded } from 'entities/deed/selectors';

import { initFailedAction, INIT, InitAction } from './types';

const init = (action$: ActionsObservable<InitAction>, store: Store) =>
  action$.ofType(INIT).mergeMap(() => {
    const state = store.getState();
    const actions = [];

    if (!selectUpcomingDeedsLoaded(state)) {
      actions.push(DeedsApi.fetchUpcoming());
    }

    return Observable.combineLatest(actions)
      .mergeMap((resultingActions) => _.flatten(resultingActions))
      .catch((e) => Observable.of(initFailedAction(e)));
  });

export default [init];
